/**
 * キャリコネクション送客のロゴ表示（連携先の企業ロゴ × yagish ロゴ）を決める純関数。
 *
 * 連携先ロゴは①（連携対象媒体取得API）が返す logo_img_url をそのまま使い、
 * 媒体ごとの合成画像は作らない。出せないときは rt_condition.content の固定画像、
 * それも無ければ「連携先名 × yagish」の文字にする。
 */

/** 単体の yagish ロゴ（ヘッダーと同じ SVG） */
export const YAGISH_LOGO_SRC = '/static/renew2_img/logo.svg'

export type CcLogoView =
  | { kind: 'composed'; mediaSrc: string }
  | { kind: 'static'; src: string }
  | { kind: 'text' }

/** https の画像 URL だけを通す（http は https のページで混在コンテンツになる） */
export function httpsImageUrl(url: unknown): string {
  const value = String(url ?? '').trim()
  return /^https:\/\/[^\s"'<>]+$/i.test(value) ? value : ''
}

export function resolveCcLogoView(
  mediaLogo: unknown,
  fallbackSrc: unknown,
  mediaLogoFailed: boolean
): CcLogoView {
  const mediaSrc = httpsImageUrl(mediaLogo)
  if (mediaSrc && !mediaLogoFailed) return { kind: 'composed', mediaSrc }
  const src = String(fallbackSrc ?? '').trim()
  if (src) return { kind: 'static', src }
  return { kind: 'text' }
}
